import { PagedResults } from '../models/generics';
import { Target } from '../models/Target';
import client from './axios';

const targetsUrl = `${window.__env.GATEWAY_URL}/v1/targets`;

export const Targets = {
  getTargets: (params?: URLSearchParams) => client.get<PagedResults<Target> | Array<Target>>(targetsUrl, { params }),
  createTarget: (body: Target) => client.post<Target>(targetsUrl, body),
  editTarget: (id: number, body: Target) => client.put<Target>(`${targetsUrl}/${id}`, body),
  deleteTarget: (id: number) => client.delete<Target>(`${targetsUrl}/${id}`),
  getTarget: (id: number) => client.get<Target>(`${targetsUrl}/${id}`),
}